// credit tiêu hao = durationSeconds × model.creditPerSecond
export const calculateTranscriptCredit = ({ durationSeconds, model }) => {
  if (!model?.creditPerSecond || !durationSeconds) return 0;
  return Math.ceil(durationSeconds * model.creditPerSecond);
};
